/* ==========================================================================
   AURUM · global.js
   ========================================================================== */
(function () {
  'use strict';

  var AURUM = window.AURUM || {};

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = AURUM.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }
  window.AURUM.formatMoney = formatMoney;

  /* ---------- Sticky header ---------- */
  var headerWrapper = document.querySelector('.header-wrapper[data-sticky="true"]');
  if (headerWrapper) {
    var lastKnown = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY || window.pageYOffset;
      if (y > 120 && lastKnown <= 120) headerWrapper.classList.add('is-stuck');
      if (y <= 120) headerWrapper.classList.remove('is-stuck');
      lastKnown = y;
    }, { passive: true });
  }

  /* ---------- Mobile navigation ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (menuToggle && nav) {
    var navScrim = document.querySelector('[data-nav-scrim]');
    var closeBtn = document.createElement('button');
    closeBtn.className = 'header__nav-close';
    closeBtn.setAttribute('aria-label', 'Close menu');
    closeBtn.textContent = '\u2715';
    nav.appendChild(closeBtn);
    function openNav() {
      nav.classList.add('is-open');
      if (navScrim) navScrim.classList.add('is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeNav() {
      nav.classList.remove('is-open');
      if (navScrim) navScrim.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    menuToggle.addEventListener('click', openNav);
    closeBtn.addEventListener('click', closeNav);
    if (navScrim) navScrim.addEventListener('click', closeNav);
    nav.addEventListener('click', function (e) { if (e.target === nav) closeNav(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 899 && nav.classList.contains('is-open')) closeNav();
    });
  }

  /* ---------- Scroll reveal ---------- */
  if (document.body.classList.contains('animations-enabled') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
    window.AURUM.observeReveal = function (el) { io.observe(el); };
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
    window.AURUM.observeReveal = function () {};
  }

  /* ---------- Cart drawer helpers ---------- */
  var drawer = document.querySelector('[data-cart-drawer-root]');

  function openDrawer() {
    if (!drawer) { window.location.href = AURUM.routes.cart; return; }
    document.body.classList.add('cart-open');
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    if (!drawer) return;
    document.body.classList.remove('cart-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-empty', count === 0 ? 'true' : 'false');
    });
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html || !drawer) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-cart-drawer-root]');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      });
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  window.AURUM.openDrawer = openDrawer;
  window.AURUM.closeDrawer = closeDrawer;
  window.AURUM.refreshDrawer = refreshDrawer;
  window.AURUM.refreshCart = refreshCart;

  /* ---------- Add to cart (delegated) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!AURUM.cartDrawer) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = '…'; }
    var body = new FormData(form);
    fetch(AURUM.routes.cartAdd + '.js', { method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshDrawer(); })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (button) { button.disabled = false; button.textContent = AURUM.strings.added || original; }
        openDrawer();
        setTimeout(function () { if (button) button.textContent = original; }, 1600);
      })
      .catch(function () {
        if (button) { button.disabled = false; button.textContent = original; }
        form.submit();
      });
  });

  /* ---------- Drawer interactions (delegated, survives re-render) ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { closeDrawer(); return; }
    var headerCart = e.target.closest('[data-cart-link]');
    if (headerCart && AURUM.cartDrawer && drawer) { e.preventDefault(); openDrawer(); return; }
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = qtyBtn.getAttribute('data-line');
      var delta = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      var wrap = qtyBtn.closest('[data-cart-item]');
      var valueEl = wrap ? wrap.querySelector('[data-qty-value]') : null;
      var current = valueEl ? parseInt(valueEl.textContent, 10) || 0 : 0;
      var next = current + delta;
      if (next < 0) next = 0;
      changeLine(line, next);
      return;
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) { changeLine(removeBtn.getAttribute('data-line'), 0); }
  });

  function changeLine(line, quantity) {
    var body = new URLSearchParams();
    body.append('line', line);
    body.append('quantity', quantity);
    fetch(AURUM.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' }, body: body.toString() })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function () { return refreshDrawer(); })
      .then(function () { return refreshCart(); })
      .catch(function () { window.location.href = AURUM.routes.cart; });
  }

  /* ---------- Cart note (drawer, debounced) ---------- */
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      var body = new URLSearchParams();
      body.append('note', note.value);
      fetch(AURUM.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
    }, 500);
  });

  /* ---------- Quantity steppers (product page / cart page) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    var value = parseInt(input.value, 10) || 0;
    var next = value + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery (Amazon-style thumbs) ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var gallerySlides = gallery.querySelectorAll('[data-gallery-slide]');
    var galleryThumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    function activateMedia(mediaId) {
      gallerySlides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === String(mediaId));
      });
      galleryThumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-target') === String(mediaId));
      });
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateMedia(thumb.getAttribute('data-target'));
      });
    });

    window.AURUM.activateMedia = activateMedia;

    /* keyboard nav */
    gallery.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var list = Array.prototype.slice.call(galleryThumbs);
      var current = list.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (current < 0) return;
      var next = e.key === 'ArrowRight' ? current + 1 : current - 1;
      if (next < 0) next = list.length - 1;
      if (next >= list.length) next = 0;
      list[next].click();
      list[next].focus();
    });
  }

  /* ---------- Product page: variant picker ---------- */
  var productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    var jsonEl = productRoot.querySelector('[data-variant-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var optionSelects = productRoot.querySelectorAll('[data-option-select]');
    var idInput = productRoot.querySelector('[data-variant-id]');
    var priceEl = productRoot.querySelector('[data-price-current]');
    var compareEl = productRoot.querySelector('[data-price-compare]');
    var buyBtn = productRoot.querySelector('[data-add-button]');

    function currentSelection() {
      var sel = [];
      optionSelects.forEach(function (s) { sel.push(s.value); });
      return sel;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function onOptionChange() {
      var variant = findVariant();
      if (!variant) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = AURUM.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? AURUM.strings.addToCart : AURUM.strings.soldOut;
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      if (variant.featured_media && variant.featured_media.id && window.AURUM.activateMedia) {
        window.AURUM.activateMedia(variant.featured_media.id);
      }
    }

    optionSelects.forEach(function (s) { s.addEventListener('change', onOptionChange); });
  }

  /* ---------- Buy it now (add to cart then straight to checkout) ---------- */
  document.addEventListener('click', function (e) {
    var buyNow = e.target.closest('[data-buy-now]');
    if (!buyNow) return;
    var form = buyNow.closest('form');
    if (!form) return;
    e.preventDefault();
    var original = buyNow.textContent;
    buyNow.disabled = true;
    buyNow.textContent = '…';
    var body = new FormData(form);
    fetch(AURUM.routes.cartAdd + '.js', { method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('failed'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        buyNow.disabled = false;
        buyNow.textContent = original;
        form.submit();
      });
  });

  /* ---------- Related products (lazy fetch) ---------- */
  var relatedHost = document.querySelector('[data-related-products]');
  if (relatedHost) {
    fetch(relatedHost.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var temp = document.createElement('div');
        temp.innerHTML = text;
        var inner = temp.querySelector('[data-related-inner]');
        if (inner && inner.innerHTML.trim().length) {
          relatedHost.innerHTML = inner.innerHTML;
          relatedHost.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
        }
      })
      .catch(function () {});
  }

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
